import React from 'react'
import { Link } from 'react-router-dom';
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next';

import SchoolIcon from "@mui/icons-material/School";
import GroupsIcon from "@mui/icons-material/Groups";
import AssessmentIcon from '@mui/icons-material/Assessment';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import UnarchiveIcon from '@mui/icons-material/Unarchive';

const Dashboard = () => {
  const { t } = useTranslation();
  
  return (
    <div className='dashboard'>
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("admin.dashboard.title")}
      </h2>
      <div className='linkButtons' style={{display: "flex", flexWrap:"wrap", gap: "1rem", paddingTop: "1rem"}}>
        <Button variant='contained' color="info" startIcon={<SchoolIcon />} component={Link} to="/school">
          {t("admin.dashboard.linkButtons_school")}
        </Button>
        <Button variant='contained' color="info" startIcon={<GroupsIcon />} component={Link} to="/facilitator">
          {t("admin.dashboard.linkButtons_facilitator")}
        </Button>
        <Button variant='contained' color="info" startIcon={<GroupsIcon />} component={Link} to="/students">
          {t("admin.dashboard.linkButtons_students")}
        </Button>
        <Button variant='contained' color="info" startIcon={<UploadFileIcon />} component={Link} to="/student-excel-upload">
          {t("admin.dashboard.linkButtons_uploadStudentList")}
        </Button>
        <Button variant='contained' color="info" startIcon={<UnarchiveIcon />} component={Link} to="/dropbox">
          {t("admin.dashboard.linkButtons_dropbox")}
        </Button>
        <Button variant='contained' color="info" startIcon={<AssessmentIcon />} component={Link} to="/results">
          {t("admin.dashboard.linkButtons_results")}
        </Button>
      </div>
    </div>
  )
}

export default Dashboard